// IMPORTANT: this file was generated using SVGR, please do not edit directly. Refer to the icon README.md for more info.
 
 
import type { FC } from 'react';

import { Icon, type IconProps } from './../../IconWrapper';

const SvgBoilerIcon: FC<IconProps> = ({ color, size, verticalAlign }) => (
  <Icon color={color} size={size} verticalAlign={verticalAlign}>
    <path
      fillRule="evenodd"
      d="M17 3H7c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1h10c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1m-4.69 12.89A.5.5 0 0 1 12 16a.5.5 0 0 1-.31-.11C11.578 15.799 9 13.69 9 11s2.578-4.799 2.69-4.89c.09-.07.2-.11.31-.11s.22.04.31.11C12.422 6.201 15 8.31 15 11s-2.578 4.799-2.69 4.89M9.01 22c-.55 0-1-.45-1-1v-1h2v1c0 .55-.45 1-1 1m6 0c-.55 0-1-.45-1-1v-1h2v1c0 .55-.45 1-1 1M12 15s-1-1.12-1-2.5 1-2.5 1-2.5 1 1.12 1 2.5-1 2.5-1 2.5"
      clipRule="evenodd"
    />
  </Icon>
);
export default SvgBoilerIcon;
SvgBoilerIcon.displayName = 'SvgBoilerIcon';
